module.exports = __webpack_public_path__ + "media/images/lonna_bg-6c9885840b16d3ae41f43a0698a2b4ab.jpg";